import { useTheme } from '@mui/material';

export const PaypalIcon = () => {
    const theme = useTheme();

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.66699 11.3333L4.00033 2H7.33366C8.0409 2 8.71918 2.28095 9.21928 2.78105C9.71937 3.28115 10.0003 3.95942 10.0003 4.66667C10.0003 5.37391 9.71937 6.05219 9.21928 6.55229C8.71918 7.05238 8.0409 7.33333 7.33366 7.33333H3.33366M6.00033 10H10.0003C10.7076 10 11.3858 9.71905 11.8859 9.21895C12.386 8.71885 12.667 8.04058 12.667 7.33333C12.667 6.62609 12.386 5.94781 11.8859 5.44772C11.3858 4.94762 10.7076 4.66667 10.0003 4.66667H6.66699L5.33366 14"
                stroke={theme.palette.text.primary}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
